import { Component, OnInit, ViewChildren } from '@angular/core';
import { IonSlides, NavController } from '@ionic/angular';
import { OpeningService } from '../services/opening.service';
import { Security } from '../utils/security.util';

@Component({
  selector: 'app-intro',
  templateUrl: './intro.page.html',
  styleUrls: ['./intro.page.scss'],
})
export class IntroPage{

  @ViewChildren('control') control: IonSlides;

  slideOpts = {
    initialSlide: 0,
    speed: 400,
    coverflowEffect: {
      rotate: 50,
      stretch: 0,
      depth: 100,
      modifier: 1,
      slideShadows: true,
    }
  };
  slides: any[];
  end = false;

  constructor(private navCtr: NavController, private service: OpeningService) { }

  ionViewDidEnter() {
    this.service.getIntro().subscribe(result => {
      this.slides = result.data;
    });
  }

  goToStore() {
    Security.setIntro(true);
    this.navCtr.navigateRoot(['/']);
  }

  ionSlideDidChange(control) {
   this.end = control.isEnd();
  }

}
